<form class="otp-card" [formGroup]="form" (ngSubmit)="submit()" autocomplete="one-time-code">
  <h2 class="otp-title">Verify your Access PIN</h2>

  <p class="otp-subtitle" *ngIf="pinStage === 'VERIFY' && !error">
    Please enter the 6 digit PIN sent to your email address.
    </p>

    <p class="otp-subtitle success-message" *ngIf="pinStage === 'NEW' && !error">
    Enter a new 6 digit PIN.
    </p>

    <p class="otp-subtitle success-message" *ngIf="pinStage === 'CONFIRM' && !error">
    Confirm your new 6 digit PIN.
    </p>

    <p class="otp-subtitle error-message" *ngIf="error">
    {{ errorMessage }}
    </p>

  <div class="otp-inputs" *ngIf="!loading && !error" role="group" aria-label="One-time password" (paste)="onPaste($event)">
    <input
      *ngFor="let _ of [].constructor(length); let i = index"
      #otpBox
      class="otp-box"
      inputmode="numeric"
      pattern="[0-9]*"
      maxlength="1"
      [attr.aria-label]="'Digit ' + (i + 1)"
      [formControlName]="'d' + i"
      (input)="onInput(i, $event)"
      (keydown)="onKeyDown(i, $event)"
    />
  </div>

  <button *ngIf="!error" class="btn btn-warning otp-btn" type="submit" [disabled]="form.invalid" [class.enabled]="!form.invalid">
    {{buttonName}}
  </button>
</form>
